export const pageUrlGenerator = (page) =>
  `${window.location.protocol}//${window.location.host}${page}`;

export const brandGames = {
  MegaDeal: {
    href: "/casino/jt-mega-deal",
    code: "",
    casino: "Jackpot",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/brand-game/MegaDeal.webp",
    alt: "Mega Deal",
    name: "Mega Deal",
    providerName: "Jackpot",
  },
  MrMars: {
    href: "/casino/jt-mr-mars",
    code: "",
    casino: "Jackpot",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/brand-game/MrMars.webp",
    alt: "Mr Mars",
    name: "Mr Mars",
    providerName: "Jackpot",
  },
  EagleLuck: {
    href: "/casino/jt-eagle-luck",
    code: "",
    casino: "Jactop",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/brand-game/EagleLuck.webp",
    alt: "Eagle Luck",
    name: "Eagle Luck",
    providerName: "Jactop",
  },
  GoldenSands: {
    href: "/casino/jt-golden-sands",
    code: "",
    casino: "Jactop",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/brand-game/GoldenSands.webp",
    alt: "Golden Sands",
    name: "Golden Sands",
    providerName: "Jactop",
  },
  // GoldenTiger: {
  //   href: "/casino/jt-golden-tiger",
  //   code: "",
  //   casino: "Jactop",
  //   provider: "Worldcasino",
  //   homeUrl: pageUrlGenerator("/home"),
  //   imgUrl: "./images/casino/brand-game/GoldenTiger.webp",
  //   alt: "Golden Tiger",
  //   name: "Golden Tiger",
  //   providerName: "Jactop",
  // },
  Poker: {
    href: "/casino/jt-poker",
    code: "",
    casino: "Jackpot",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/brand-game/Poker.webp",
    alt: "Poker",
    name: "Poker",
    providerName: "Jackpot",
  },
  JackYourWins: {
    href: "/casino/jt-jack-your-wins",
    code: "",
    casino: "Jactop",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/brand-game/JackYourWins.webp",
    alt: "Jack Your Wins",
    name: "Jack Your Wins",
    providerName: "Jactop",
  },
  JungleHippo: {
    href: "/casino/jt-jungle-hippo",
    code: "",
    casino: "Jactop",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/brand-game/JungleHippo.webp",
    alt: "Jungle Hippo",
    name: "Jungle Hippo",
    providerName: "Jactop",
  },
  JungleJack: {
    href: "/casino/jt-jungle-jack",
    code: "",
    casino: "Jactop",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/brand-game/JungleJack.webp",
    alt: "Jungle Jack",
    name: "Jungle Jack",
    providerName: "Jactop",
  },
  KennelsAndCash: {
    href: "/casino/jt-kennels-and-cash",
    code: "",
    casino: "Jactop",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/brand-game/Kennels&Cash.webp",
    alt: "Kennels & Cash",
    name: "Kennels & Cash",
    providerName: "Jactop",
  },
  LuckyDiva: {
    href: "/casino/jt-lucky-diva",
    code: "",
    casino: "Jactop",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/brand-game/LuckyDiva.webp",
    alt: "Lucky Diva",
    name: "Lucky Diva",
    providerName: "Jactop",
  },
  MacaoLadder: {
    href: "/casino/jt-macao-ladder",
    code: "",
    casino: "Jactop",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/brand-game/MacaoLadder.webp",
    alt: "Macao Ladder",
    name: "Macao Ladder",
    providerName: "Jactop",
  },
  MayanMask: {
    href: "/casino/jt-mayan-mask",
    code: "",
    casino: "Jactop",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/brand-game/MayanMask.webp",
    alt: "Mayan  Mask",
    name: "Mayan Mask",
    providerName: "Jactop",
  },
  Roulette: {
    href: "/casino/jt-roulette",
    code: "",
    casino: "Jackpot",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/brand-game/Roulette.webp",
    alt: "Roulette",
    name: "Roulette",
    providerName: "Jackpot",
  },
  Bacarat: {
    href: "/casino/jt-bacarat",
    code: "",
    casino: "Jackpot",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/brand-game/Bacarat.webp",
    alt: "Bacarat",
    name: "Bacarat",
    providerName: "Jackpot",
  },
  BlackJack: {
    href: "/casino/jt-blackjack",
    code: "",
    casino: "Jackpot",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/brand-game/BlackJack.webp",
    alt: "BlackJack",
    name: "BlackJack",
    providerName: "Jackpot",
  },
  BlackJack7Auto: {
    href: "/casino/jt-blackjack7-auto",
    code: "",
    casino: "Jackpot",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/brand-game/BlackJack7Auto.webp",
    alt: "BlackJack 7 Auto",
    name: "BlackJack 7 Auto",
    providerName: "Jackpot",
  },
  BlackJack7Illusion: {
    href: "/casino/jt-blackjack7-illusion",
    code: "",
    casino: "Jackpot",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/brand-game/BlackJack7Illusion.webp",
    alt: "BlackJack 7 Illusion",
    name: "BlackJack 7 Illusion",
    providerName: "Jackpot",
  },
  BlackJack7Mirage: {
    href: "/casino/jt-blackjack7-mirage",
    code: "",
    casino: "Jackpot",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/brand-game/BlackJack7Mirage.webp",
    alt: "BlackJack 7 Mirage",
    name: "BlackJack 7 Mirage",
    providerName: "Jackpot",
  },
  Blackjack7Nova: {
    href: "/casino/jt-blackjack-7-nova",
    code: "",
    casino: "Jackpot",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/brand-game/Blackjack7Nova.webp",
    alt: "Blackjack 7 Nova",
    name: "Blackjack 7 Nova",
    providerName: "Jackpot",
  },
  BlackJack7Phantom: {
    href: "/casino/jt-blackjack-7-phantom",
    code: "",
    casino: "Jackpot",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/brand-game/BlackJack7Phantom.webp",
    alt: "BlackJack 7 Phantom",
    name: "BlackJack 7 Phantom",
    providerName: "Jackpot",
  },
  CrossFireChickenx5000: {
    href: "/casino/jt-154912",
    code: "",
    casino: "Jackpot",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/brand-game/CrossFireChickenx5000.webp",
    alt: "Cross Fire Chicken x5000",
    name: "Cross Fire Chicken x5000",
    providerName: "Jackpot",
  },
  GoldenMirageRoulette: {
    href: "/casino/jt-golden-mirage-roulette",
    code: "",
    casino: "Jackpot",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/brand-game/GoldenMirageRoulette.webp",
    alt: "Golden Mirage Roulette",
    name: "Golden Mirage Roulette",
    providerName: "Jackpot",
  },
  LuckyChickenCrossing: {
    href: "/casino/jt-140511",
    code: "",
    casino: "Jackpot",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/brand-game/LuckyChickenCrossing.webp",
    alt: "Lucky Chicken Crossing",
    name: "Lucky Chicken Crossing",
    providerName: "Jackpot",
  },
  RuletaAmazonica: {
    href: "/casino/jt-ruleta-amazonica",
    code: "",
    casino: "Jackpot",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/brand-game/RuletaAmazonica.webp",
    alt: "Ruleta Amazonica",
    name: "Ruleta Amazonica",
    providerName: "Jackpot",
  },
  SpaceBallRoulette: {
    href: "/casino/jt-space-ball-roulette",
    code: "",
    casino: "Jackpot",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/brand-game/SpaceBallRoulette.webp",
    alt: "Space Ball Roulette",
    name: "Space Ball Roulette",
    providerName: "Jackpot",
  },
  SteamRoulette: {
    href: "/casino/jt-steam-roulette",
    code: "",
    casino: "Jackpot",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/brand-game/SteamRoulette.webp",
    alt: "Steam Roulette",
    name: "Steam Roulette",
    providerName: "Jackpot",
  },
  TeenpattiAuto: {
    href: "/casino/jt-teen-patti-auto",
    code: "",
    casino: "Jackpot",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/brand-game/TeenpattiAuto.webp",
    alt: "Teenpatti Auto",
    name: "Teenpatti Auto",
    providerName: "Jackpot",
  },
  VIPVaultRoulette: {
    href: "/casino/jt-vip-vault-roulette",
    code: "",
    casino: "Jackpot",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/brand-game/VIPVaultRoulette.webp",
    alt: "VIP Vault Roulette",
    name: "VIP Vault Roulette",
    providerName: "Jackpot",
  },
  Baccarat: {
    href: "/casino/jt-bacarat",
    code: "",
    casino: "Jactop",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/brand-game/Baccarat.webp",
    alt: "Baccarat",
    name: "Baccarat",
    providerName: "Jactop",
  },
  BanktheCash: {
    href: "/casino/jt-bank-the-cash",
    code: "",
    casino: "Jactop",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/brand-game/BanktheCash.webp",
    alt: "Bank the Cash",
    name: "Bank the Cash",
    providerName: "Jactop",
  },
  BattleforTroy: {
    href: "/casino/jt-battle-for-troy",
    code: "",
    casino: "Jactop",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/brand-game/BattleforTroy.webp",
    alt: "Battle for Troy",
    name: "Battle for Troy",
    providerName: "Jactop",
  },
  BlackjackArena: {
    href: "/casino/jt-blackjack-arena",
    code: "",
    casino: "Jactop",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/brand-game/BlackjackArena.webp",
    alt: "Blackjack Arena",
    name: "Blackjack Arena",
    providerName: "Jactop",
  },
  BladeMasters: {
    href: "/casino/jt-blade-masters",
    code: "",
    casino: "Jactop",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/brand-game/BladeMasters.webp",
    alt: "Blade Masters",
    name: "Blade Masters",
    providerName: "Jactop",
  },
  BonusPoker: {
    href: "/casino/jt-bonus-poker",
    code: "",
    casino: "Jactop",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/brand-game/BonusPoker.webp",
    alt: "Bonus Poker",
    name: "Bonus Poker",
    providerName: "Jactop",
  },
  // BrawlersBucks: {
  //   href: "/casino/jt-brawlers-bucks",
  //   code: "",
  //   casino: "Jactop",
  //   provider: "Worldcasino",
  //   homeUrl: pageUrlGenerator("/home"),
  //   imgUrl: "./images/casino/brand-game/BrawlersBucks.webp",
  //   alt: "Brawlers Bucks",
  //   name: "Brawlers Bucks",
  //   providerName: "Jactop",
  // },
  DoubleBallRoulette: {
    href: "/casino/jt-double-ball-roulette",
    code: "",
    casino: "Jactop",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/brand-game/DoubleBallRoulette.webp",
    alt: "Double Ball Roulette",
    name: "Double Ball Roulette",
    providerName: "Jactop",
  },
  FeatheredFortunes: {
    href: "/casino/jt-feathered-fortunes",
    code: "",
    casino: "Jactop",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/brand-game/FeatheredFortunes.webp",
    alt: "Feathered Fortunes",
    name: "Feathered Fortunes",
    providerName: "Jactop",
  },
  FlockofFortune: {
    href: "/casino/jt-flock-of-fortune",
    code: "",
    casino: "Jactop",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/brand-game/FlockofFortune.webp",
    alt: "Flock o fFortune",
    name: "Flock of Fortune",
    providerName: "Jactop",
  },
  GettheBank2: {
    href: "/casino/jt-get-the-bank-2",
    code: "",
    casino: "Jactop",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/brand-game/GettheBank2.webp",
    alt: "Get the Bank 2",
    name: "Get the Bank 2",
    providerName: "Jactop",
  },
  GoldSuperPot: {
    href: "/casino/jt-gold-super-pot",
    code: "",
    casino: "Jactop",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/brand-game/GoldSuperPot.webp",
    alt: "Gold Super Pot",
    name: "Gold Super Pot",
    providerName: "Jactop",
  },
  GoldWagon: {
    href: "/casino/jt-gold-wagon",
    code: "",
    casino: "Jactop",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/brand-game/GoldWagon.webp",
    alt: "Gold Wagon",
    name: "Gold Wagon",
    providerName: "Jactop",
  },
  HighStakesInTheHenHouse: {
    href: "/casino/jt-high-stakes-in-the-hen-house",
    code: "",
    casino: "Jactop",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/brand-game/HighStakesInTheHenHouse.webp",
    alt: "High Stakes In The Hen House",
    name: "High Stakes In The Hen House",
    providerName: "Jactop",
  },
  MexicanFiesta: {
    href: "/casino/jt-mexican-fiesta",
    code: "",
    casino: "Jactop",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/brand-game/MexicanFiesta.webp",
    alt: "Mexican Fiesta",
    name: "Mexican Fiesta",
    providerName: "Jactop",
  },
  OrangeRiverBigBass: {
    href: "/casino/jt-orange-river-big-bass",
    code: "",
    casino: "Jactop",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/brand-game/OrangeRiverBigBass.webp",
    alt: "Orange River Big Bass",
    name: "Orange River Big Bass",
    providerName: "Jactop",
  },
  OrcWars: {
    href: "/casino/jt-orc-wars",
    code: "",
    casino: "Jactop",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/brand-game/OrcWars.webp",
    alt: "Orc Wars",
    name: "Orc Wars",
    providerName: "Jactop",
  },
  PaiGowPoker: {
    href: "/casino/jt-pai-gow-poker",
    code: "",
    casino: "Jactop",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/brand-game/PaiGowPoker.webp",
    alt: "Pai Gow Poker",
    name: "Pai Gow Poker",
    providerName: "Jactop",
  },
  QuickBlackjack: {
    href: "/casino/jt-quick-blackjack",
    code: "",
    casino: "Jactop",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/brand-game/QuickBlackjack.webp",
    alt: "Quick Blackjack",
    name: "Quick Blackjack",
    providerName: "Jactop",
  },
  RouletteMultiplier: {
    href: "/casino/jt-roulette-multiplier",
    code: "",
    casino: "Jactop",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/brand-game/RouletteMultiplier.webp",
    alt: "Roulette Multiplier",
    name: "Roulette Multiplier",
    providerName: "Jactop",
  },
  SecretsofOlympus: {
    href: "/casino/jt-secrets-of-olympus",
    code: "",
    casino: "Jactop",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/brand-game/SecretsofOlympus.webp",
    alt: "Secrets of Olympus",
    name: "Secrets of Olympus",
    providerName: "Jactop",
  },
  SidebetPokerHoldem: {
    href: "/casino/jt-sidebet-poker-holdem",
    code: "",
    casino: "Jactop",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/brand-game/SidebetPokerHoldem.webp",
    alt: "Sidebet Poker Holdem",
    name: "Sidebet Poker Holdem",
    providerName: "Jactop",
  },
  StacksOnTheStrip: {
    href: "/casino/jt-stacks-on-the-strip",
    code: "",
    casino: "Jactop",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/brand-game/StacksOnTheStrip.webp",
    alt: "Stacks On The Strip",
    name: "Stacks On The Strip",
    providerName: "Jactop",
  },
  SuperHoldem: {
    href: "/casino/jt-super-holdem",
    code: "",
    casino: "Jactop",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/brand-game/SuperHoldem.webp",
    alt: "Super Holdem",
    name: "Super Holdem",
    providerName: "Jactop",
  },
  WarehouseWonga: {
    href: "/casino/jt-warehouse-wonga",
    code: "",
    casino: "Jactop",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/brand-game/WarehouseWonga.webp",
    alt: "Warehouse Wonga",
    name: "Warehouse Wonga",
    providerName: "Jactop",
  },
};

export const jactopGames = {
  AllGames: {
    href: "/brand-games",
    code: "",
    casino: "Jactop",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/providers/AllGames.webp",
    alt: "All Games",
    name: "All Games",
    providerName: "Jactop",
  },
  Crash: {
    href: "/casino/spribe/aviator",
    code: "",
    casino: "spribe",
    provider: "spribe",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/providers/Crash.webp",
    alt: "Crash",
    name: "Crash",
    providerName: "spribe",
  },
  BattleforTroy: {
    href: "/casino/jt-battle-for-troy",
    code: "",
    casino: "Jactop",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/providers/BattleforTroy.webp",
    alt: "Battle for Troy",
    name: "Battle for Troy",
    providerName: "Jactop",
  },
  BonusPoker: {
    href: "/casino/jt-bonus-poker",
    code: "",
    casino: "Jactop",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/providers/BonusPoker.webp",
    alt: "Bonus Poker",
    name: "Bonus Poker",
    providerName: "Jactop",
  },
  EagleLuck: {
    href: "/casino/jt-eagle-luck",
    code: "",
    casino: "Jactop",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/providers/EagleLuck.webp",
    alt: "Eagle Luck",
    name: "Eagle Luck",
    providerName: "Jactop",
  },
  GoldenSands: {
    href: "/casino/jt-golden-sands",
    code: "",
    casino: "Jactop",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/providers/GoldenSands.webp",
    alt: "Golden Sands",
    name: "Golden Sands",
    providerName: "Jactop",
  },
  // GoldenTiger: {
  //   href: "/casino/jt-golden-tiger",
  //   code: "",
  //   casino: "Jactop",
  //   provider: "Worldcasino",
  //   homeUrl: pageUrlGenerator("/home"),
  //   imgUrl: "./images/casino/providers/GoldenTiger.webp",
  //   alt: "Golden Tiger",
  //   name: "Golden Tiger",
  //   providerName: "Jactop",
  // },
  JungleHippo: {
    href: "/casino/jt-jungle-hippo",
    code: "",
    casino: "Jactop",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/providers/JungleHippo.webp",
    alt: "Jungle Hippo",
    name: "Jungle Hippo",
    providerName: "Jactop",
  },
  JungleJack: {
    href: "/casino/jt-jungle-jack",
    code: "",
    casino: "Jactop",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/providers/JungleJack.webp",
    alt: "Jungle Jack",
    name: "Jungle Jack",
    providerName: "Jactop",
  },
  LuckyDiva: {
    href: "/casino/jt-lucky-diva",
    code: "",
    casino: "Jactop",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/providers/LuckyDiva.webp",
    alt: "Lucky Diva",
    name: "Lucky Diva",
    providerName: "Jactop",
  },
  MayanMask: {
    href: "/casino/jt-mayan-mask",
    code: "",
    casino: "Jactop",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/providers/MayanMask.webp",
    alt: "Mayan  Mask",
    name: "Mayan Mask",
    providerName: "Jactop",
  },
  BanktheCash: {
    href: "/casino/jt-bank-the-cash",
    code: "",
    casino: "Jactop",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/providers/BanktheCash.webp",
    alt: "Bank the Cash",
    name: "Bank the Cash",
    providerName: "Jactop",
  },
  BladeMasters: {
    href: "/casino/jt-blade-masters",
    code: "",
    casino: "Jactop",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/providers/BladeMasters.webp",
    alt: "Blade Masters",
    name: "Blade Masters",
    providerName: "Jactop",
  },
  // BrawlersBucks: {
  //   href: "/casino/jt-brawlers-bucks",
  //   code: "",
  //   casino: "Jactop",
  //   provider: "Worldcasino",
  //   homeUrl: pageUrlGenerator("/home"),
  //   imgUrl: "./images/casino/providers/BrawlersBucks.webp",
  //   alt: "Brawlers Bucks",
  //   name: "Brawlers Bucks",
  //   providerName: "Jactop",
  // },
  DoubleBallRoulette: {
    href: "/casino/jt-double-ball-roulette",
    code: "",
    casino: "Jactop",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/providers/DoubleBallRoulette.webp",
    alt: "Double Ball Roulette",
    name: "Double Ball Roulette",
    providerName: "Jactop",
  },
  FeatheredFortunes: {
    href: "/casino/jt-feathered-fortunes",
    code: "",
    casino: "Jactop",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/providers/FeatheredFortunes.webp",
    alt: "Feathered Fortunes",
    name: "Feathered Fortunes",
    providerName: "Jactop",
  },
  FlockofFortune: {
    href: "/casino/jt-flock-of-fortune",
    code: "",
    casino: "Jactop",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/providers/FlockofFortune.webp",
    alt: "Flock o fFortune",
    name: "Flock of Fortune",
    providerName: "Jactop",
  },
  GettheBank2: {
    href: "/casino/jt-get-the-bank-2",
    code: "",
    casino: "Jactop",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/providers/GettheBank2.webp",
    alt: "Get the Bank 2",
    name: "Get the Bank 2",
    providerName: "Jactop",
  },
  GoldSuperPot: {
    href: "/casino/jt-gold-super-pot",
    code: "",
    casino: "Jactop",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/providers/GoldSuperPot.webp",
    alt: "Gold Super Pot",
    name: "Gold Super Pot",
    providerName: "Jactop",
  },
  GoldWagon: {
    href: "/casino/jt-gold-wagon",
    code: "",
    casino: "Jactop",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/providers/GoldWagon.webp",
    alt: "Gold Wagon",
    name: "Gold Wagon",
    providerName: "Jactop",
  },
  HighStakesInTheHenHouse: {
    href: "/casino/jt-high-stakes-in-the-hen-house",
    code: "",
    casino: "Jactop",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/providers/HighStakesInTheHenHouse.webp",
    alt: "High Stakes In The Hen House",
    name: "High Stakes In The Hen House",
    providerName: "Jactop",
  },
  Baccarat: {
    href: "/casino/jt-bacarat",
    code: "",
    casino: "Jactop",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/providers/Baccarat.webp",
    alt: "Baccarat",
    name: "Baccarat",
    providerName: "Jactop",
  },
  BlackjackArena: {
    href: "/casino/jt-blackjack-arena",
    code: "",
    casino: "Jactop",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/providers/BlackjackArena.webp",
    alt: "Blackjack Arena",
    name: "Blackjack Arena",
    providerName: "Jactop",
  },
  JackYourWins: {
    href: "/casino/jt-jack-your-wins",
    code: "",
    casino: "Jactop",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/providers/JackYourWins.webp",
    alt: "Jack Your Wins",
    name: "Jack Your Wins",
    providerName: "Jactop",
  },
  KennelsAndCash: {
    href: "/casino/jt-kennels-and-cash",
    code: "",
    casino: "Jactop",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/providers/Kennels&Cash.webp",
    alt: "Kennels & Cash",
    name: "Kennels & Cash",
    providerName: "Jactop",
  },
  MacaoLadder: {
    href: "/casino/jt-macao-ladder",
    code: "",
    casino: "Jactop",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/providers/MacaoLadder.webp",
    alt: "Macao Ladder",
    name: "Macao Ladder",
    providerName: "Jactop",
  },
  MexicanFiesta: {
    href: "/casino/jt-mexican-fiesta",
    code: "",
    casino: "Jactop",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/providers/MexicanFiesta.webp",
    alt: "Mexican Fiesta",
    name: "Mexican Fiesta",
    providerName: "Jactop",
  },
  OrangeRiverBigBass: {
    href: "/casino/jt-orange-river-big-bass",
    code: "",
    casino: "Jactop",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/providers/OrangeRiverBigBass.webp",
    alt: "Orange River Big Bass",
    name: "Orange River Big Bass",
    providerName: "Jactop",
  },
  OrcWars: {
    href: "/casino/jt-orc-wars",
    code: "",
    casino: "Jactop",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/providers/OrcWars.webp",
    alt: "Orc Wars",
    name: "Orc Wars",
    providerName: "Jactop",
  },
  PaiGowPoker: {
    href: "/casino/jt-pai-gow-poker",
    code: "",
    casino: "Jactop",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/providers/PaiGowPoker.webp",
    alt: "Pai Gow Poker",
    name: "Pai Gow Poker",
    providerName: "Jactop",
  },
  QuickBlackjack: {
    href: "/casino/jt-quick-blackjack",
    code: "",
    casino: "Jactop",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/providers/QuickBlackjack.webp",
    alt: "Quick Blackjack",
    name: "Quick Blackjack",
    providerName: "Jactop",
  },
  RouletteMultiplier: {
    href: "/casino/jt-roulette-multiplier",
    code: "",
    casino: "Jactop",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/providers/RouletteMultiplier.webp",
    alt: "Roulette Multiplier",
    name: "Roulette Multiplier",
    providerName: "Jactop",
  },
  SecretsofOlympus: {
    href: "/casino/jt-secrets-of-olympus",
    code: "",
    casino: "Jactop",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/providers/SecretsofOlympus.webp",
    alt: "Secrets of Olympus",
    name: "Secrets of Olympus",
    providerName: "Jactop",
  },
  SidebetPokerHoldem: {
    href: "/casino/jt-sidebet-poker-holdem",
    code: "",
    casino: "Jactop",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/providers/SidebetPokerHoldem.webp",
    alt: "Sidebet Poker Holdem",
    name: "Sidebet Poker Holdem",
    providerName: "Jactop",
  },
  StacksOnTheStrip: {
    href: "/casino/jt-stacks-on-the-strip",
    code: "",
    casino: "Jactop",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/providers/StacksOnTheStrip.webp",
    alt: "Stacks On The Strip",
    name: "Stacks On The Strip",
    providerName: "Jactop",
  },
  SuperHoldem: {
    href: "/casino/jt-super-holdem",
    code: "",
    casino: "Jactop",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/providers/SuperHoldem.webp",
    alt: "Super Holdem",
    name: "Super Holdem",
    providerName: "Jactop",
  },
  WarehouseWonga: {
    href: "/casino/jt-warehouse-wonga",
    code: "",
    casino: "Jactop",
    provider: "Worldcasino",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "./images/casino/providers/WarehouseWonga.webp",
    alt: "Warehouse Wonga",
    name: "Warehouse Wonga",
    providerName: "Jactop",
  },
};
